var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.891,
    height: 11.499,
    viewBox: "0 0 7.891 11.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-burn-4061221",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125002",
    "data-name": "Path 125002",
    d: "M25.219,41.15c.171,1.08-2.056,1.841-.946,3.645,0,0,.046.063.05.065a5.167,5.167,0,0,0,1.177.206,3.722,3.722,0,0,0,.4-.014l.027-.031C26.3,44.571,27.444,42.754,25.219,41.15Z",
    transform: "translate(-21.39 -33.567)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125003",
    "data-name": "Path 125003",
    d: "M16.844,4.565c-.9.108-1.092,1.129-1.092,1.129-.266-.255-.2-.84-.171-2.024a2.187,2.187,0,0,0-1.057-2.08,2.311,2.311,0,0,1-.235,2.538c-.051-.937-.48-.96-1.081-2.111A1.787,1.787,0,0,1,13.427,0,2.433,2.433,0,0,0,11.7,2.3c.014,1.26-.514,1.578-.514,1.578a1.526,1.526,0,0,0-1.182-1.669,2.369,2.369,0,0,1-.384,2.475,4.288,4.288,0,0,0-.206,4.24,4.319,4.319,0,0,0,2.18,1.736,3.771,3.771,0,0,1-.889-3.87,1.542,1.542,0,0,1,.38.732,1.8,1.8,0,0,1,.636-1.321,1.89,1.89,0,0,0,.744-1.842A2.491,2.491,0,0,1,13.6,6.378a1.6,1.6,0,0,1,1.028-.97,1.484,1.484,0,0,0-.2,1.184c.161.715,1.028,1.942.447,3.136a2.485,2.485,0,0,1-1.26,1.212,3.037,3.037,0,0,0,2.833-3.782C16.159,5.247,16.844,4.565,16.844,4.565Z",
    transform: "translate(-8.953 0)",
    fill: "#5142fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.f9d308a695e05811bdf2541fa6e8ee58.svg";
export { ForwardRef as ReactComponent };